'use strict';exports.__esModule = true;exports.DEFAULT_DISPLAYED_PINS = exports.OPTION_TYPES_COMPANY = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactScroll = require('react-scroll');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _AboutStaff = require('./AboutStaff/AboutStaff');var _AboutStaff2 = _interopRequireDefault(_AboutStaff);
var _components = require('../../components');
var _CompanyProperties = require('./CompanyProperties/CompanyProperties');var _CompanyProperties2 = _interopRequireDefault(_CompanyProperties);
var _CompanyRealtors = require('../CompanyRealtors/CompanyRealtors');var _CompanyRealtors2 = _interopRequireDefault(_CompanyRealtors);
var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);

var _constants = require('../../constants');





var _services = require('../../services');
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _Company = require('./Company.scss');var styles = _interopRequireWildcard(_Company);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Component
// Constants
// Helpers
// styles
var OPTION_TYPES_COMPANY = exports.OPTION_TYPES_COMPANY = { SALE: 'forSale', RENT: 'forRent' };

var DEFAULT_DISPLAYED_PINS = exports.DEFAULT_DISPLAYED_PINS = OPTION_TYPES_COMPANY.SALE;
var consultationImage = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573656970/professionals/partnership';var

RealtorUser = function (_Component) {_inherits(RealtorUser, _Component);
  function RealtorUser(props) {_classCallCheck(this, RealtorUser);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    var propertiesForSell = _this.getPropertiesFor('buy', props);
    var propertiesForRent = _this.getPropertiesFor('rent', props);

    _this.state = {
      propertiesForSell: propertiesForSell,
      propertiesForRent: propertiesForRent };return _this;

  }RealtorUser.prototype.

  componentWillMount = function componentWillMount() {
    this.detectLanguage(this.props);
  };RealtorUser.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var

    properties =



    nextProps.properties,staffData = nextProps.staffData,descriptionData = nextProps.descriptionData,locale = nextProps.locale;
    if (locale !== this.props.locale) {
      this.props.resetTranslate();

      this.detectLanguage(nextProps);
    }

    if (
    descriptionData.showOriginal &&
    !descriptionData.loading &&
    !descriptionData.loaded)
    {
      this.props.translateDescription({ q: staffData.description.he });
    }

    if (properties && properties.length && (!this.props.properties || !this.props.properties.length) ||
    !(0, _isEqual2.default)(properties, this.props.properties)) {
      var propertiesForSell = this.getPropertiesFor('buy', nextProps);
      var propertiesForRent = this.getPropertiesFor('rent', nextProps);

      this.setState({
        propertiesForSell: propertiesForSell,
        propertiesForRent: propertiesForRent });

    }
  };RealtorUser.prototype.






















































































  render = function render() {
    var bgPhotos = {
      imgCompany: { backgroundImage: 'url(\'' + _constants.DEFAULT_MAIN_IMAGE + '\')' },
      imgConsultation: { backgroundImage: 'url(\'' + consultationImage + '\')' },
      bgContactsForm: { backgroundImage: 'url(\'' + _constants.realtorLandingBottomBackground + '\')' } };var _props =

    this.props,locale = _props.locale,route = _props.route,descriptionData = _props.descriptionData,staffData = _props.staffData,routeData = _props.routeData;

    var sharingData = {
      sharingUrl: (0, _makeSharingUrl2.default)('/staff/' + routeData.optionType, locale),
      sharingTitle: staffData.name };

    var formattedImage = _constants.DEFAULT_MAIN_IMAGE;

    var descriptionText = !descriptionData.showOriginal ?
    (0, _get2.default)(staffData, 'description.' + locale) || (0, _get2.default)(staffData, 'description.he') :
    descriptionData.translatedText;

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement('div', { className: styles.headerTop },
          _react2.default.createElement('span', { className: styles.bgCover, style: bgPhotos.imgConsultation }),
          _react2.default.createElement('div', { className: styles.container },
            _react2.default.createElement(_AboutStaff2.default, {
              translate: this.props.translate('companyPage'),
              staffData: staffData,
              companyLogo: formattedImage,
              locale: locale,
              isMobile: this.props.isMobile })),


          _react2.default.createElement('div', { className: styles.container },
            this.renderShareButton(sharingData))),


        _react2.default.createElement(_reactScroll.Element, { name: 'company-page-content' },
          _react2.default.createElement('div', { className: styles.descriptionTextBlockWrapper },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.container, styles.flexContainer) },
              _react2.default.createElement(_components.DescriptionTextBlock, {
                className: 'companyDescriptions',
                contentText: descriptionText,
                locale: locale,
                translate: this.props.translate,
                title: 'descriptionRealtorTitle',
                description: this.props.staffData.description,
                descriptionData: this.props.descriptionData,
                toggleDescriptionTranslation: this.props.toggleDescriptionTranslation,
                isTranslate: true }))),



          this.renderProperties((0, _get2.default)(staffData, 'company_name.' + locale) || (0, _get2.default)(staffData, 'company_name.he')))));



  };return RealtorUser;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.componentWillUnmount = function () {_this2.props.resetTranslate();};this.getPropertiesFor = function (optionType) {var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.props;if (!props.properties) {return null;}var additionalTypes = optionType === 'rent' ? ['rent-short'] : [];return props.properties && props.properties.filter(function (prop) {return [optionType].concat(additionalTypes).includes(prop.option_type);});};this.detectLanguage = function (props) {var locale = props.locale,detectDescriptionLanguage = props.detectDescriptionLanguage;var description = (0, _get2.default)(props, 'staffData.description', null);if (description) {var _getLocalizedData = (0, _getLocalizedData3.default)(description, locale),result = _getLocalizedData.result;detectDescriptionLanguage({ q: result, locale: locale });}};this.openDetails = function (evt, propertyId) {var entityType = 'property';var route = (0, _appendLocale2.default)(_this2.props.locale, '/home_details/' + propertyId);var state = Object.assign({}, _this2.props.routeData, { pid: propertyId });if (evt.ctrlKey || evt.metaKey) {window.open(route);} else {_reactRouter.browserHistory.push({ pathname: _this2.props.route + '/pid_' + propertyId, state: state });_this2.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });} // hermione event
    _services.AnalyticsEventService.createPropertyEvent({ propertyId: propertyId, action: _constants.analyticsEventAction.VIEW });};this.renderShareButton = function (sharingData) {return _react2.default.createElement(_components.ShareButtonsRow, { isNative: _this2.props.isNative, sharingData: sharingData, isMobile: _this2.props.isMobile, locale: _this2.props.locale, copyLinkTitle: '' + _this2.props.translate('copyLink'), shareTitle: '' + _this2.props.translate('companyPage', 'shareTitle'), className: 'companySocialIcons', isHideShareTitle: true });};this.renderProperties = function (localizedCompanyName) {if (!(0, _get2.default)(_this2.props, 'properties.length')) {return null;}return _react2.default.createElement('div', { className: styles.container }, _react2.default.createElement(_CompanyProperties2.default, { translate: _this2.props.translate, locale: _this2.props.locale, isRtl: _this2.props.isRtl, isMobile: _this2.props.isMobile, forSale: _this2.state.propertiesForSell, forRent: _this2.state.propertiesForRent, openDetails: _this2.openDetails, companyName: localizedCompanyName }));};};

RealtorUser.propTypes = {
  properties: _propTypes2.default.array,
  routeData: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  route: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  descriptionData: _propTypes2.default.object,
  staffData: _propTypes2.default.object,
  translateDescription: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  resetTranslate: _propTypes2.default.func,
  detectDescriptionLanguage: _propTypes2.default.func };exports.default =


RealtorUser;


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/RealtorUser.js
// module id = 560
// module chunks = 0